var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.1594mm",
    height: "5.1594mm",
    viewBox: "0 0 5.1593747 5.1593747",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-98.636 -223.49)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.15445 0 0 .14202 99.322 224.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.06 8.11 1.415 1.415a7 7 0 0 1 0 9.9l-0.354 0.353a7.0004 7.0004 0 0 1 -9.9 -9.9l1.415 1.415a5 5 0 1 0 7.071 7.071l0.354-0.354a5 5 0 0 0 0 -7.07l-1.415-1.415 1.415-1.414zm6.718 6.011-1.414-1.414a5 5 0 1 0 -7.071 -7.071l-0.354 0.354a5 5 0 0 0 0 7.07l1.415 1.415-1.415 1.414-1.414-1.414a7 7 0 0 1 0 -9.9l0.354-0.353a7.0004 7.0004 0 0 1 9.9 9.9z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 98.041 222.89)",
    fill: "none",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 3.6v16.8c0 0.3314-0.2686 0.6-0.6 0.6h-16.8c-0.33137 0-0.6-0.2686-0.6-0.6v-16.8c0-0.33137 0.26863-0.6 0.6-0.6h16.8c0.3314 0 0.6 0.26863 0.6 0.6z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.6265946bc95fa18309dd0f83be2417c5.svg";
export { ForwardRef as ReactComponent };